import _ from 'underscore';

import {
    RailwayLeg, RailwayRoute, RailwayTariff, Station,
} from '@ve/types';

import { ApiRailwayRoute } from '@ve/types/railway/ApiRailwayRoute';
import { ApiRailwayLeg } from '@ve/types/railway/ApiRailwayLeg';
import groupVariants from '@/js/common/Domain/Service/searchTour/service/apiTourToTourAdapter/groupVariants';
import { RailwayLegInfo } from '@/js/common/components/railwayTours/Domain/service/types';

import legsAdapter from './legsAdapter';

export default ({
                    routes: apiRoutes,
                    legs,
                    tariffs,
                    stations,
                }:
                    {
                        routes: ApiRailwayRoute[],
                        legs: ApiRailwayLeg[],
                        tariffs: RailwayTariff[],
                        stations?: Station[]
                    }): RailwayRoute[] => {
    const referencesIndex = {
        legKeys: _.indexBy(legs, 'id'),
        tariffKeys: _.indexBy(tariffs, 'id'),
        stationKeys: stations ? _.indexBy(stations, 'id') : {},
    };

    return _.reduce(apiRoutes, (routes, apiRoute) => {
        const thereAvailableLegs = legsAdapter({
            ...referencesIndex,
            legs: apiRoute.there.legs,
        });
        const backAvailableLegs = legsAdapter({
            ...referencesIndex,
            legs: apiRoute.back.legs,
        });

        const groupedThereLegs = groupVariants(thereAvailableLegs);
        const groupedBackLegs = groupVariants(backAvailableLegs);

        const groupedLegs = groupVariants([groupedThereLegs, groupedBackLegs]);

        groupedLegs.forEach((groupedLeg) => {
            const [thereLegs, backLegs] = groupedLeg;

            const collectLegInfo = (legsData: RailwayLegInfo[]) => legsData.reduce((legsInfo, leg) => {
                legsInfo.id.push(leg.id);
                legsInfo.legs.push(leg.leg);
                return {
                    ...legsInfo,
                    totalPrice: legsInfo.totalPrice + leg.additionalTax,
                };
            }, {
                id: [] as string[],
                totalPrice: 0,
                legs: [] as RailwayLeg[],
            });

            const there = collectLegInfo(thereLegs);
            const back = collectLegInfo(backLegs);

            const route = {
                pk: `${apiRoute.id}__${there.id.join('_')}__${back.id.join('_')}`,
                routeId: apiRoute.id,
                additionalTax: there.totalPrice + back.totalPrice,
                there: {
                    legs: there.legs,
                    routeTime: apiRoute.there.routeTime,
                },
                back: {
                    legs: back.legs,
                    routeTime: apiRoute.back.routeTime,
                },
            };
            routes.push(route);
        });

        return routes;
    }, [] as RailwayRoute[]);
};
